
import { MapLocation } from '@/types/location';
import { regionCenters } from './regionCenters';
import { tableAdsLocations } from './tableAdsLocations';
import { alanGymLocations } from './gyms';
import { alanCafeLocations } from './cafes';
import { alanGameCenterLocations } from './gameCenters';
import { nonWakiSchoolLocations, wakiSchools } from './schools';
import { attentionOutdoorLocations } from './attentionOutdoorLocations';
import { rotanaSignsLocations } from './rotanaSignsLocations';
import { onSpotLocations } from './onSpotLocations';
import { waveMediaLocations } from './waveMediaLocations';

// Debug logging to check if locations are being loaded
console.log('Loading locations data:');
console.log('TableAds locations:', tableAdsLocations?.length || 0);
console.log('Alan gym locations:', alanGymLocations?.length || 0);
console.log('Alan cafe locations:', alanCafeLocations?.length || 0);
console.log('Alan game center locations:', alanGameCenterLocations?.length || 0);
console.log('Non-Waki school locations:', nonWakiSchoolLocations?.length || 0);
console.log('Waki schools:', wakiSchools?.length || 0);
console.log('Attention outdoor locations:', attentionOutdoorLocations?.length || 0);
console.log('Attention location details:', attentionOutdoorLocations);

// Ensure we have valid locations to avoid mapping errors
const validLocations = (locations: MapLocation[]) => {
  const valid = Array.isArray(locations) ? locations : [];
  console.log(`Validated ${valid.length} locations`);
  return valid;
};

// Deterministic ID assignment for any locations missing IDs
const ensureIds = (locs: MapLocation[]): MapLocation[] => {
  const used = new Set<number>();
  locs.forEach((l) => { if (typeof l.id === 'number' && !isNaN(l.id)) used.add(l.id); });

  const hash = (s: string) => {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
    }
    return Math.abs(h >>> 0);
  };

  let assigned = 0;
  const result = locs.map((l) => {
    if (typeof l.id === 'number' && !isNaN(l.id)) return l;
    const key = `${l.name}|${l.region}|${l.mediaOwner}|${l.type}|${(l as any).coordinates?.join(',') ?? ''}`;
    let id = hash(key);
    while (used.has(id)) id++;
    used.add(id);
    assigned++;
    return { ...l, id } as MapLocation;
  });

  if (assigned > 0) {
    console.log(`ensureIds: Assigned IDs to ${assigned} locations`);
  }
  return result;
};

// Combine all locations - putting Attention first to ensure it's included
// TableAds locations removed - marked as "Coming Soon"
const combined: MapLocation[] = [
  ...validLocations(attentionOutdoorLocations),
  // ...validLocations(tableAdsLocations), // Removed - Coming Soon
  ...validLocations(alanGymLocations), 
  ...validLocations(alanCafeLocations),
  ...validLocations(alanGameCenterLocations),
  ...validLocations(nonWakiSchoolLocations),
  ...validLocations(wakiSchools),
  ...validLocations(rotanaSignsLocations),
  ...validLocations(onSpotLocations),
  ...validLocations(waveMediaLocations),
];

export const locations: MapLocation[] = ensureIds(combined);


console.log('Total combined locations:', locations.length);
console.log('Attention locations in final array:', locations.filter(loc => loc.mediaOwner === 'Attention').length);
console.log('All Attention locations:', locations.filter(loc => loc.mediaOwner === 'Attention'));

// Re-export region centers
export { regionCenters };
